import React from 'react';
import { ReactNode } from 'react';

import './Alert.scss';
import { PrimeIcons } from 'primereact/api';
import classNames from 'classnames';
import { Button } from 'primereact/button';

export type AlertSeverity = 'info' | 'warning' | 'error';

interface Props {
  children: ReactNode;
  className?: string;
  severity?: AlertSeverity;
  handleClose?: () => void;
  hidden?: boolean;
  hideIcon?: boolean;
  textSize?: 'small' | 'normal';
}

const getAlertIcon = (severity: AlertSeverity) => {
  switch (severity) {
    case 'info':
      return PrimeIcons.INFO_CIRCLE;
    case 'warning':
      return PrimeIcons.EXCLAMATION_TRIANGLE;
    case 'error':
      return PrimeIcons.TIMES_CIRCLE;
  }
};

export const Alert = ({
  children,
  severity = 'info',
  className,
  hidden = false,
  handleClose,
  hideIcon = false,
  textSize = 'normal',
}: Props) => {
  if (hidden) return null;

  return (
    <div className={classNames('alert', severity, className, { 'small-text': textSize === 'small' })}>
      {!hideIcon && <i className={classNames(getAlertIcon(severity), 'alert-icon')} />}
      <div className='alert-content'>{children}</div>
      {handleClose && (
        <Button onClick={handleClose} icon={PrimeIcons.TIMES} className='alert-close-button' text severity='danger' rounded />
      )}
    </div>
  );
};
